import { useCallback, useEffect, useState } from "react";

export function useEmailConfirmed(
  isEmailMeWhenAvailableProduct: boolean,
  id: string,
): boolean {
  const [isEmailConfirmed, setIsEmailConfirmed] = useState(false);

  const handleEmailMeEvent = useCallback(
    (event: Event) => {
      const customEvent = event as CustomEvent<string>;
      if (customEvent.detail === id) {
        setIsEmailConfirmed(true);
      }
    },
    [id],
  );

  useEffect(() => {
    if (isEmailMeWhenAvailableProduct) {
      window.addEventListener("jl.emailMe.success", handleEmailMeEvent);
    }
    return () => {
      window.removeEventListener("jl.emailMe.success", handleEmailMeEvent);
    };
  }, [isEmailMeWhenAvailableProduct, handleEmailMeEvent]);

  return isEmailConfirmed;
}
